import { render, staticRenderFns } from "./fmInsTypeResult.vue?vue&type=template&id=0ec29910"
import script from "./fmInsTypeResult.vue?vue&type=script&lang=js"
export * from "./fmInsTypeResult.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports